/* Only operates on the v2 comparison section; product and cart handlers are separate. */
(function () {
  'use strict';
  function readCompareContext(search, catalog) {
    var query = new URLSearchParams(search);
    var ids = catalog.map(function (product) { return product.id; });
    var requested = Array.from(new Set((query.get('models') || '').split(',').filter(function (id) { return ids.includes(id); }))).slice(0, 2);
    var returnProduct = catalog.find(function (product) { return product.id === query.get('return_model'); });
    var returnVariant = returnProduct && returnProduct.variants.find(function (variant) { return String(variant.id) === query.get('return_variant'); });
    var pair = requested.length ? requested : [(returnProduct && returnProduct.id) || ids[0]];
    ids.forEach(function (id) { if (pair.length < 2 && !pair.includes(id)) pair.push(id); });
    return { pair: pair, returnProduct: returnVariant ? returnProduct : null, returnVariant: returnVariant || null };
  }
  function swapComparison(pair, position, next) {
    var result = pair.slice();
    var previous = result[position];
    var other = position === 0 ? 1 : 0;
    result[position] = next;
    if (result[other] === next) result[other] = previous;
    return result;
  }
  function sameColorPacks(product, color) {
    return [1, 2, 3].map(function (size) { return product.variants.find(function (variant) { return (variant.packSize || 1) === size && (variant.color || '') === (color || ''); }); });
  }
  function defaultComparisonVariant(product) {
    var preferred = product.primaryKit ? 3 : 1;
    return product.variants.find(function (variant) { return (variant.packSize || 1) === preferred && variant.available; }) || product.variants.find(function (variant) { return (variant.packSize || 1) === preferred; }) || product.variants[0];
  }
  function variantForComparisonColor(product, current, color) {
    return product.variants.find(function (variant) { return (variant.color || '') === color && (variant.packSize || 1) === ((current && current.packSize) || 1); });
  }
  function comparePurchaseUrl(product, variant) {
    return window.MLI18n.url(product.url) + (variant ? '?variant=' + encodeURIComponent(variant.id) : '');
  }
  var helpers = { readCompareContext: readCompareContext, swapComparison: swapComparison, sameColorPacks: sameColorPacks, defaultComparisonVariant: defaultComparisonVariant, variantForComparisonColor: variantForComparisonColor, comparePurchaseUrl: comparePurchaseUrl };
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof document === 'undefined') return;
  function boot(root) {
    if (root.dataset.cmpReady) return;
    var source = root.querySelector('[data-cmp-catalog]');
    if (!source) return;
    var payload;
    try { payload = JSON.parse(source.textContent); } catch (error) { return; }
    var catalog = payload.products;
    if (!Array.isArray(catalog) || catalog.length < 2) return;
    root.dataset.cmpReady = 'true';
    var context = readCompareContext(window.location.search, catalog);
    var pair = context.pair;
    var selected = {};
    var currency = payload.currency || 'USD';
    var format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
    function money(value) { return format.format(value / 100); }
    catalog.forEach(function (product) {
      selected[product.id] = context.returnProduct && context.returnProduct.id === product.id ? context.returnVariant : defaultComparisonVariant(product);
    });
    function renderPair() {
      catalog.forEach(function (product) {
        var card = root.querySelector('[data-cmp-model="' + product.id + '"]');
        if (!card) return;
        var index = pair.indexOf(product.id);
        card.dataset.selected = index >= 0 ? 'true' : 'false';
        card.style.order = index >= 0 ? String(index) : '9';
      });
      root.querySelectorAll('[data-cmp-selector]').forEach(function (select) { select.value = pair[Number(select.dataset.cmpSelector)]; });
      var url = new URL(window.location.href);
      url.searchParams.set('models', pair.join(','));
      if (!context.returnVariant) { url.searchParams.delete('return_model'); url.searchParams.delete('return_variant'); }
      window.history.replaceState(window.history.state, '', url);
    }
    function renderCard(product) {
      var card = root.querySelector('[data-cmp-model="' + product.id + '"]');
      var variant = selected[product.id];
      if (!card || !variant) return;
      var color = variant.color || '';
      var packs = sameColorPacks(product, color);
      var savings = !product.primaryKit && packs[0] && packs[1] ? packs[0].price * 2 - packs[1].price : 0;
      var colorSelect = card.querySelector('[data-cmp-color]');
      if (colorSelect) {
        colorSelect.value = color;
        Array.from(colorSelect.options).forEach(function (option) { option.disabled = !variantForComparisonColor(product, variant, option.value); });
      }
      var photo = card.querySelector('[data-cmp-image]');
      if (photo) { photo.src = variant.image || product.image; photo.alt = product.model + ' ' + window.MLI18n.display(color || product.baseColor); }
      card.querySelector('[data-cmp-image-link]').href = comparePurchaseUrl(product, variant);
      card.querySelectorAll('[data-cmp-pack]').forEach(function (button) {
        var size = Number(button.dataset.cmpPack);
        var option = packs[size - 1];
        button.disabled = !option || !option.available;
        button.setAttribute('aria-pressed', String(Boolean(option && option.id === variant.id)));
        button.setAttribute('aria-label', product.model + ', ' + (size === 3 && option?.packLabel === '1 device + standard accessories' ? window.MLI18n.pack(option.packLabel) : size === 3 ? window.MLI18n.t("s_9dee7514c9c2_html", {}, "Device + 1 extra set") : size === 2 ? window.MLI18n.pack('2-pack') : window.MLI18n.pack('1 device')) + (option ? ', ' + money(option.price) : window.MLI18n.t("s_a8d840b22187_html", {}, ", unavailable")));
        button.querySelector('[data-cmp-pack-price]').textContent = option ? money(option.price) : window.MLI18n.t("s_ca1844969742_html");
        button.querySelector('[data-cmp-saving]').textContent = !option || !option.available ? window.MLI18n.t("s_ca1844969742_html") : size === 2 && savings > 0 ? window.MLI18n.t("save_two_html", {amount: money(savings)}) : option.packLabel === '2-pack + 2 extra mask sets' ? 'Two devices + 2 extra mask sets' : option.packLabel === '1 device + standard accessories' ? window.MLI18n.pack(option.packLabel) : size === 3 ? window.MLI18n.t("s_ea9c6c99b76a_html", {}, "One device + 1 extra mask & mouthpiece set") : size === 2 ? window.MLI18n.t("s_86e0d9856dc1_html", {}, "Two complete device kits") : window.MLI18n.t("s_86f086516a08_html", {}, "One device kit");
      });
      card.querySelector('[data-cmp-pack-summary]').textContent = variant.packLabel === '2-pack + 2 extra mask sets' ? product.model + ': two devices with standard accessories + 2 extra mask sets.' : variant.packSize === 2 ? (color ? window.MLI18n.t("compare_two_color_html", {model: product.model, color: window.MLI18n.display(color)}) : window.MLI18n.t("compare_two_html", {model: product.model})) : variant.packLabel === '1 device + standard accessories' ? product.model + ': ' + window.MLI18n.pack(variant.packLabel) : variant.packSize === 3 ? (color ? window.MLI18n.t("compare_extra_color_html", {model: product.model, color: window.MLI18n.display(color)}) : window.MLI18n.t("compare_extra_html", {model: product.model})) : (color ? window.MLI18n.t("compare_one_color_html", {model: product.model, color: window.MLI18n.display(color)}) : window.MLI18n.t("compare_one_html", {model: product.model}));
      var buy = card.querySelector('[data-cmp-buy]');
      buy.href = comparePurchaseUrl(product, variant);
      buy.querySelector('[data-cmp-buy-label]').textContent = variant.available ? window.MLI18n.t("choose_model_html", {model: product.model}) : window.MLI18n.t("s_93b4279f3e9d_html", {}, "View availability");
      buy.classList.toggle('secondary', !variant.available);
    }
    function setView(view) {
      root.dataset.view = view;
      root.querySelectorAll('[data-cmp-view]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.cmpView === view)); });
    }
    if (context.returnProduct) {
      var returnBox = root.querySelector('[data-cmp-return]');
      var returnLink = returnBox.querySelector('a');
      var choice = [window.MLI18n.display(context.returnVariant.color), window.MLI18n.pack(context.returnVariant.packLabel)].filter(Boolean).join(' · ');
      returnBox.querySelector('strong').textContent = context.returnProduct.model + ' · ' + choice;
      returnLink.href = comparePurchaseUrl(context.returnProduct, context.returnVariant) + '#mayluck-purchase';
      returnLink.querySelector('span').textContent = window.MLI18n.t("return_model_html", {model: context.returnProduct.model});
      returnBox.hidden = false;
    }
    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('[data-cmp-selector]')) {
        if (!catalog.some(function (product) { return product.id === target.value; })) return;
        pair = swapComparison(pair, Number(target.dataset.cmpSelector), target.value);
        setView('pair');
        renderPair();
      }
      if (target.matches('[data-cmp-color]')) {
        var id = target.closest('[data-cmp-model]').dataset.cmpModel;
        var product = catalog.find(function (item) { return item.id === id; });
        var previous = selected[id];
        var next = variantForComparisonColor(product, previous, target.value);
        if (!next) { target.value = previous.color || ''; return; }
        selected[id] = next;
        renderCard(product);
      }
    });
    root.addEventListener('click', function (event) {
      var packButton = event.target.closest('[data-cmp-pack]');
      if (packButton && root.contains(packButton) && !packButton.disabled) {
        var id = packButton.closest('[data-cmp-model]').dataset.cmpModel;
        var product = catalog.find(function (item) { return item.id === id; });
        var next = sameColorPacks(product, selected[id].color)[Number(packButton.dataset.cmpPack) - 1];
        if (next && next.available) { selected[id] = next; renderCard(product); }
      }
      var viewButton = event.target.closest('[data-cmp-view]');
      if (viewButton && root.contains(viewButton)) setView(viewButton.dataset.cmpView);
    });
    renderPair();
    catalog.forEach(renderCard);
  }
  function bootAll() { document.querySelectorAll('[data-ml-compare-v2]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
